import { apiClient } from "shared/api/client";

export const getDashboard = ({ apiUrl, organizationSymbol, branchSymbol }) => {
  const args =
    branchSymbol && branchSymbol !== "dashboard"
      ? `${organizationSymbol}/${branchSymbol}`
      : organizationSymbol;

  return apiClient(`${apiUrl}/ti/api/v1/${args}/dashboard`);
};